import {Component, Input, OnInit, SimpleChange, SimpleChanges} from '@angular/core';
import { finalize } from 'rxjs/operators';

import {ShoppingService} from '@app/shopping/shopping.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {AuthenticationService, Credentials, I18nService, Logger} from '@app/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {UtilityService} from '../core/utils.service';
import {environment} from '@env/environment';
import {CustomerModel} from '../../models/customer.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService, FacebookLoginProvider, GoogleLoginProvider, SocialUser} from 'angularx-social-login';
import {Http} from '@angular/http';
import {CustomerService} from '@app/customer/customer.service';
import {DatePipe} from '@angular/common';
import {AccreditedService} from '@app/accredited/accredited.service';

const log = new Logger('Login');

@Component({
  selector: 'app-home',
  templateUrl: './sorteio.nf.component.html',
  styleUrls: ['./sorteio.nf.component.scss']
})
export class SorteioNfComponent implements OnInit {
  isLoading = false;
  nfmodel : any = null;

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private i18nService: I18nService,
              private authenticationService: AuthenticationService,
              private http: Http,
              private authService: AuthService,
              private customerService: CustomerService,
              private datePipe: DatePipe,
              private modalService: NgbModal,
              private route: ActivatedRoute,
              private util: UtilityService,
              private accreditedService:
 AccreditedService) {
  }

  ngOnInit() {
  }

  execute() {
    this.isLoading = true;
    this.customerService.lotery()
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe(res => {
        if (res) {
            this.nfmodel = res;
        } else {
          alert('Erro ao realizar cadastro.');
        }

      }, error => {
        alert('Erro ao realizar cadastro.');
      });
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/sorteio-nf/sorteio.nf.component.ts